// extracted by mini-css-extract-plugin
export default {"ariaSkipLinksContainer":"xi-z"};